export default __webpack_public_path__ + "media/images/archetypes/oracle-4e739da31c4643e92c4749277e65dc56.png";